export function parseIntWithDefault(
  value: unknown,
  defaultValue: number,
): number {
  if (typeof value === 'number') {
    return value;
  }
  if (typeof value !== 'string') {
    return defaultValue;
  }
  const parsedValue = parseInt(value, 10);
  if (Number.isNaN(parsedValue)) {
    return defaultValue;
  }
  return parsedValue;
}
